//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

enum PostableStatus {
  Cancelled = 'Cancelled',
  Dispatched = 'Dispatched',
  Failed = 'Failed',
  Pending = 'Pending',
  Posted = 'Posted',
  Processing = 'Processing',
  ProcessingComplete = 'ProcessingComplete',
  Rescheduled = 'Rescheduled',
  Scheduled = 'Scheduled',
}

export default PostableStatus;
